var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_375",
    "data-name": "Group 375",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_circle_FILL0_wght400_GRAD0_opsz48",
    d: "M95,206a14.514,14.514,0,0,1-5.813-1.181,15.113,15.113,0,0,1-8.006-8.006,14.983,14.983,0,0,1,0-11.662,14.991,14.991,0,0,1,3.225-4.762,15.376,15.376,0,0,1,4.781-3.206,14.983,14.983,0,0,1,11.663,0,14.976,14.976,0,0,1,7.969,7.969,14.984,14.984,0,0,1,0,11.662,15.377,15.377,0,0,1-3.206,4.781,14.991,14.991,0,0,1-4.763,3.225A14.607,14.607,0,0,1,95,206Z",
    transform: "translate(-80 -176)",
    fill: "#70c38d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "check_circle_FILL0_wght400_GRAD0_opsz48-2",
    "data-name": "check_circle_FILL0_wght400_GRAD0_opsz48",
    d: "M89.6,193.286l10.585-10.648-1.721-1.693L89.6,189.862l-4.488-4.515-1.683,1.693ZM91.8,186.438Z",
    transform: "translate(-76.804 -171.442)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green_tick.6ab8b1d42863101d688acdf30b183e2b.svg";
export { ForwardRef as ReactComponent };